module.exports = __webpack_public_path__ + "img/2deddc9a5f2547e4b630bcc33586cfeb_mergeImage.5e5b1888.png";